// src/components/CrearCredenciales.js
import React, { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { useLocation, useNavigate } from 'react-router-dom';
import './CrearCredenciales.css';

const CrearCredenciales = () => {
  const [message, setMessage] = useState('Cargando...');
  const [showLoginButton, setShowLoginButton] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const token = new URLSearchParams(location.search).get('token');

  useEffect(() => {
    const processToken = async () => {
      if (!token) {
        setMessage('Token inválido.');
        return;
      }

      const docRef = doc(db, 'proposalTokens', token);
      const snap = await getDoc(docRef);

      if (!snap.exists()) {
        setMessage('Token expirado o no encontrado.');
        return;
      }

      const { email: storedEmail, clientInfo, items, total, deposit, remaining } = snap.data();
      const email = storedEmail || clientInfo?.email || '';

      try {
        const response = await fetch('https://handleclientresponse-xjpm53xzha-uc.a.run.app', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email,
            response: 'accept',
            clientInfo,
            items,
            total,
            deposit,
            remaining,
            proposalToken: token
          })
        });

        const data = await response.json();

        if (response.ok) {
          if (data.resetLink) {
            setMessage('Redirigiendo al enlace de contraseña...');
            window.location.href = data.resetLink;
          } else if (data.alreadyRegistered) {
            setMessage('Ya tienes cuenta. Ingresa con tus credenciales.');
            setShowLoginButton(true);
          } else {
            setMessage('Propuesta procesada correctamente.');
            setShowLoginButton(true);
          }
        } else {
          setMessage(data.error || 'Error procesando respuesta del cliente.');
          setShowLoginButton(true);
        }

      } catch (err) {
        console.error('❌ Error general:', err);
        setMessage('Ocurrió un error al procesar la propuesta.');
        setShowLoginButton(true);
      }
    };

    processToken();
  }, [token]);

  return (
    <div className="crear-wrapper">
      <div className="crear-box">
        <img src="/logo-bbts.png" alt="Logo BBTS" className="login-logo" />
        <h2>{message}</h2>
        {showLoginButton && (
          <button className="btn-login" onClick={() => navigate('/login')}>
            Ir al panel de acceso
          </button>
        )}
      </div>
    </div>
  );
};

export default CrearCredenciales;
